import { ResponsiveContainer, XAxis, YAxis, Tooltip, LabelList, ScatterChart, Scatter, Label, ZAxis, ReferenceLine, Legend } from "recharts";
import { formatNumber } from "../../utils/formatter";

const PerformanceMetricsChart = (props: any) => {
    const data = props.data;
    let totalX = 0;
    let totalY= 0;
    let minX = 0;
    let minY = 0;
    props.data.map((item:any)=>{
        if (item.id != '1') 
        {
            if(minX > item.x){
                minX = item.x;
            }
            if(minY > item.y){
                minY = item.y;
            }
            totalX = totalX + item.x;
            totalY = totalY + item.y;
        }
    })
    const diviFactor:any = 10;
    let xExtra = Math.floor(minX / diviFactor) * diviFactor;
    let yExtra = Math.floor(minY / diviFactor) * diviFactor;
    const refX = (totalX + xExtra)/(props.data.length);
    const refY = (totalY + yExtra)/(props.data.length);


    const customTooltip = ({ active, payload }: any) => {
        if (active && payload && payload.length) {
            const data = payload[0].payload;
            return (
                 <div className="bg-[rgba(35,35,35,0.95)] p-3 rounded">
                <div className="grid grid-cols-[auto_1fr] gap-x-6 gap-y-1 text-white">
                    <span className="text-[#aaa]">ID</span>
                    <span className="text-right">{data.id}</span>
                    <span className="text-[#aaa]">On Hand Qty</span>
                    <span className="text-right">{formatNumber(data.onHandQty)}</span>
                    <span className="text-[#aaa]">Devalued Qty</span>
                    <span className="text-right">{formatNumber(data.devaluedQty)}</span>
                    <span className="text-[#aaa]">Non Stock Qty</span>
                    <span className="text-right">{formatNumber(data.nonStockQty)}</span>
                    <span className="text-[#aaa]">Gross Margin</span>
                    <span className="text-right">{Number(data.y)?.toFixed(2)}%</span>
                    <span className="text-[#aaa]">Turns</span>
                    <span className="text-right">{Number(data.x)?.toFixed(1)}</span>
                    <span className="text-[#aaa]">GMROI</span>
                    <span className="text-right">{Number(data.gmroi)?.toFixed(2)}</span>
                </div>
            </div>
            )
        }
    }

    const fillColor = (item: any) => {
        if (item.x < refX && item.y < refY) {
            return '#d55454'
        } else if (item.x < refX && item.y >= refY) {
            return '#c79c38';
        } else if (item.x > refX && item.y >= refY) {
            return '#008b00'
        } else {
            return '#60b5bf'
        }
    }

    // Define quadrant legend items
    const quadrantLegends = [
        { color: '#008b00', label: 'High Turns - High Margin' },
        { color: '#c79c38', label: 'Low Turns - High Margin' },
        { color: '#d55454', label: 'Low Turns - Low Margin' },
        { color: '#60b5bf', label: 'High Turns - Low Margin' }
    ];
const renderLegend = (props: any) => {
    const { payload } = props;
    
    return (
        <ul className="flex items-center gap-4 mb-6">
            {payload.map((entry: any, index: number) => (
                <li key={`legend-item-${index}`} className="flex items-center">
                    <svg 
                        width="12" 
                        height="12" 
                        viewBox="0 0 12 12" 
                        style={{ overflow: 'visible' }}
                    >
                        <circle cx="6" cy="6" r="5" fill={entry.color} />
                    </svg>
                    <span 
                        style={{ color: entry.color }} 
                        className="ml-1 font-semibold text-[0.6vw]"
                    >
                        {entry.value}
                    </span>
                </li>
            ))}
        </ul>
    );
};

  const handlePointClick = (point: any) => {
    if (typeof props.onPointClick === 'function') {
      props.onPointClick(point);
    }
  };

    return (
        <>
            <ResponsiveContainer id='capture-area' width="100%" height="100%">
                <ScatterChart
                    margin={{
                        top: -10,
                        right: 50,
                        bottom: 20,
                        left: 20,
                    }}
                >
                    <XAxis
                        type="number"
                        dataKey="x"
                        stroke="#949494"
                        domain={([dataMin, dataMax]) => {
                            const divFactor = 10;
                           return [((Math.floor(dataMin / divFactor) * divFactor) < 2 && (Math.floor(dataMin)>2) ? 2 : (Math.floor(dataMin / divFactor) * divFactor) ), ((Math.ceil(dataMax / divFactor) * (divFactor)) > 7.5 ? 7.5 : (Math.ceil(dataMax / divFactor) * (divFactor)) )];
                        }}
                        
                    >
                        <Label value="Turns" offset={0} position="bottom" style={{ fill: '#949494', fontSize: 14  }} />
                    </XAxis>
                    <YAxis stroke="#949494" dataKey="y" unit="%" domain={([dataMin, dataMax]) => {
                        const divFactor = dataMax > 100 ? 20 : 10;
                        return [Math.floor(dataMin / divFactor) * divFactor, ((Math.ceil(dataMax / divFactor) * (divFactor)) > 75 ? 75 :(Math.ceil(dataMax / divFactor) * (divFactor)))];
                    }}>
                        <Label value="Gross Margin (%)" angle={-90} position="insideLeft" style={{ fill: '#949494', textAnchor: 'middle', fontSize: 14  }} />
                    </YAxis>
                    {/* <ZAxis type="number" dataKey="y" range={data.length <= 10 ? [100, 2000] : [50, 500]}></ZAxis> */}
                    <Legend
                        verticalAlign="top"
                        align="left"
                        content={renderLegend}
                        payload={quadrantLegends.map(item => ({
                            id: item.label,
                            type: 'circle',
                            value: item.label,
                            color: item.color
                        }))}
                    />
                    <ReferenceLine x={refX} label={{ position: 'top', fill: '#ce9178', value: (refX.toFixed(1)) , fontStyle: 'italic' }} stroke="black" strokeDasharray="5 3" opacity={0.3} />

                    <ReferenceLine y={refY} label={{ position: 'right', fill: '#ce9178', value: (refY.toFixed(1)) + '%', fontStyle: 'italic' }} stroke="black" strokeDasharray="5 3" opacity={0.3} />

                    <Tooltip contentStyle={{ color: "white", backgroundColor: "rgb(26, 25, 22)" }} cursor={{ strokeDasharray: "3 3" }} content={customTooltip} />
                    {data.map((d: any, index: number) => {

                        if ( d.x > 7.5 || d.y > 75) {
                            return null;
                          }

                        return <>
                            <Scatter key={index} data={[d]} 
                            fill={fillColor(d)} 
                            onClick={() => handlePointClick(d)} 
                            // fill={'#c79c38'} 
                           >
                            </Scatter>
                        </>
                    })}

                </ScatterChart>
            </ResponsiveContainer >

        </>
    )
}

export default PerformanceMetricsChart;